import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OnlineAnswerService } from "src/app/services/onlineanswer.service";

@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.css"],
})
export class PaymentComponent implements OnInit {
  objact: any;
  currentStatus: number;
  price: number;
  paymentLink: string = "";
  fullname: string = "";
  acceptionNumber: string = "";
  downloadLink: string = "";
  constructor(
    private onlineAnswerService: OnlineAnswerService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    //this.onlineAnswerService
    this.route.params.subscribe((p) => {
      let acceptionNumber = p.acn.replace("-", "");
      let phoneNumber = p.phone;

      //this.currentStatus = 3;
      this.onlineAnswerService
        .GetStatusAnswer(acceptionNumber, phoneNumber)
        .subscribe((resp: any) => {
          
          this.objact=resp;
       

          console.log("answer status: ", resp);
          this.currentStatus = resp.fAnswerStatusMilestone;
          this.price = resp.fDebtPrice;
          this.fullname = resp.fFirstName + " " + resp.fLastName;
          this.acceptionNumber = resp.fAcceptionNumber;
          if (resp.fAnswerStatusMilestone == 7 && resp.fDebtPrice > 0) {
            this.currentStatus = 6;
            var thisSiteUrl ="http://valiasrlab.com";// document.location.origin;
            var fReturnUrlSuccess =
              thisSiteUrl +
              "/PaymentSucceeded?key=" +
              resp.fAcceptionNumber +
              "_" +
              phoneNumber;
            var fReturnUrlFailure = thisSiteUrl + "/PaymentFailure";
            this.paymentLink = this.onlineAnswerService.GetAcceptionPaymentUrl(
              resp.fCode.toString(),
              fReturnUrlSuccess,
              fReturnUrlFailure
            );
          }
          if (resp.fAnswerStatusMilestone == 7) {
            this.downloadLink = this.onlineAnswerService.GetDownloadAnswerUrl(
              acceptionNumber,
              phoneNumber
            );
          }
        });
    });
  }
  redirect():void{
   
    document.location.href = this.paymentLink;
  }
}
